import { render, staticRenderFns } from "./stockFormView.vue?vue&type=template&id=03657a34&scoped=true&"
import script from "./stockFormView.vue?vue&type=script&lang=js&"
export * from "./stockFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03657a34",
  null
  
)

export default component.exports